import { apiRoute, authHeader, handleResponse } from '../helpers'

export const adminService = {
  getUsers,
  updateUserRole,
  registerUser
}

function getUsers () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/admin/users', requestOptions).then(handleResponse)
}

function updateUserRole (userId, payload) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }

  return fetch(apiRoute() + `/api/v1/admin/users/${userId}`, requestOptions).then(handleResponse)
}

function registerUser (payload) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, recaptcha: 'dummy' })
  }

  return fetch(apiRoute() + '/auth/v1/register', requestOptions).then(handleResponse)
}
